import script from "./IframeView.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeView.vue?vue&type=script&setup=true&lang=js"

import "./IframeView.vue?vue&type=style&index=0&id=d2e25e5e&lang=css"

const __exports__ = script;

export default __exports__